import { InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { Chat } from '../Chat'

/** `filter.sourceChatId` names the conversation to merge; the rest of `filter` is the search. */
@InputType()
export class GetMergeableChatsArgs extends QueryArgs<Chat> {}
